import { createContext, useContext, useState, ReactNode } from "react";

type HeaderContextType = {
  rightContextContent: ReactNode | null;
  setRightContextContent: (content: ReactNode | null) => void;
};

const HeaderContext = createContext<HeaderContextType | null>(null);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {

  const [rightContextContent, setRightContextContent] = useState<ReactNode | null>(null);
  

  return (
    <HeaderContext.Provider value={{ rightContextContent, setRightContextContent }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeader = () => {
  const ctx = useContext(HeaderContext);

  if (!ctx) {
    throw new Error("useHeader must be used inside HeaderProvider");
  }

  return ctx;
};